export default __webpack_public_path__ + "static/Vector-3212b49a5d2c370e9fa9f2782f827d87.png";